"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroPersonal() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section className="relative min-h-screen bg-background overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12 min-h-screen flex items-center">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 w-full items-center">
          {}
          <div ref={imageRef} className="lg:col-span-2 relative h-[500px] lg:h-[700px] rounded-lg overflow-hidden" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0)" : "translateY(40px)",
          transition: "opacity 500ms ease-out, transform 500ms ease-out"
        }}>
            
            <img src="https://guillermobogao.com/wp-content/uploads/2026/02/IMG_5186-3.jpg" alt="Guillermo Bogao" className="w-full h-full object-cover object-center" />
          </div>

          {}
          <div ref={containerRef} className="lg:col-span-3 space-y-6" style={{
          opacity: containerVisible ? 1 : 0,
          transform: containerVisible ? "translateY(0)" : "translateY(30px)",
          transition: "opacity 350ms ease-out 200ms, transform 350ms ease-out 200ms"
        }}>
            
           <div className="font-sans text-lg md:text-xl lg:text-2xl text-muted-foreground space-y-4">
  <p>
    Durante años probé distintos caminos profesionales.
    Emprendimientos, ideas, proyectos.
    Nada terminaba de sostenerse.
  </p>

  <p className="!font-bold">
    No era falta de capacidad.
    Era falta de foco.
  </p>

  <p>
    Mi atención estaba puesta fuera: en los resultados, en las expectativas,
    en lo que “debía” pasar.
    Y cada vez que eso no ocurría, la frustración volvía.
  </p>

  <p>
    El punto de inflexión llegó cuando entendí algo esencial:
    solo tenía control sobre mí.
  </p>

  <p>
    Y que sin claridad interna,
    cualquier dirección se diluye.
  </p>

  <p>
    A partir de ahí comenzó un proceso de orden,
    escucha y conciencia.
  </p>

  <p>Menos ruido.</p>
  <p>Más sentido.</p>

  <p>
    Hoy tengo claro cuál es mi camino y mi propósito.
    Y desde ese lugar acompaño a personas que se sienten
    como yo me sentía entonces:
    frustradas, con potencial,
    pero sin un foco claro hacia dónde seguir.
  </p>

  <p>
    Creo profundamente que la claridad no se encuentra fuera.
    Se construye dentro.
  </p>
          </div>
          </div>
        </div>
      </div>
    </section>;
}